module.exports = ".privateImages {\r\n    cursor: default;\r\n    color: initial !important;\r\n}\r\n\r\n.content-desc-legend td {\r\n    vertical-align: top;\r\n    padding: 3px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/ms-details-content/ms-details-content.component.css
// module id = ./src/app/components/ui/ms-details-content/ms-details-content.component.css
// module chunks = main